import { render, staticRenderFns } from "./TableSupport.vue?vue&type=template&id=a55e3ecc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TableSupport.vue?vue&type=script&lang=js"
export * from "./TableSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55e3ecc",
  null
  
)

export default component.exports